import { render, staticRenderFns } from "./facebookReport.vue?vue&type=template&id=fcf18e52&scoped=true"
import script from "./facebookReport.vue?vue&type=script&lang=js"
export * from "./facebookReport.vue?vue&type=script&lang=js"
import style0 from "./facebookReport.vue?vue&type=style&index=0&id=fcf18e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf18e52",
  null
  
)

export default component.exports